var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 20.3125V14.8438C2.3462 14.0157 2.67622 13.2223 3.26174 12.6367C3.84727 12.0512 4.6407 11.7212 5.46875 11.7188H19.5312C20.3593 11.7212 21.1527 12.0512 21.7383 12.6367C22.3238 13.2223 22.6538 14.0157 22.6562 14.8438V20.3125M18.75 11.7188H4.6875V6.64062C4.68905 6.1231 4.89532 5.62721 5.26126 5.26126C5.62721 4.89532 6.1231 4.68905 6.64062 4.6875H18.3594C18.8769 4.68905 19.3728 4.89532 19.7387 5.26126C20.1047 5.62721 20.311 6.1231 20.3125 6.64062V11.7188H18.75Z",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 20.3125V19.9219C2.34465 19.6114 2.46841 19.3138 2.68798 19.0942C2.90755 18.8747 3.2051 18.7509 3.51562 18.75H21.4844C21.7949 18.7509 22.0924 18.8747 22.312 19.0942C22.5316 19.3138 22.6553 19.6114 22.6562 19.9219V20.3125M5.46875 11.7188V10.9375C5.46991 10.5235 5.6349 10.1267 5.92768 9.83393C6.22045 9.54115 6.61721 9.37616 7.03125 9.375H10.9375C11.3515 9.37616 11.7483 9.54115 12.0411 9.83393C12.3338 10.1267 12.4988 10.5235 12.5 10.9375M12.5 10.9375V11.7188M12.5 10.9375C12.5012 10.5235 12.6662 10.1267 12.9589 9.83393C13.2517 9.54115 13.6485 9.37616 14.0625 9.375H17.9688C18.3828 9.37616 18.7795 9.54115 19.0723 9.83393C19.3651 10.1267 19.5301 10.5235 19.5312 10.9375V11.7188",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bed-icon.a4b814cb.svg";
export { ForwardRef as ReactComponent };